import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=eba4628e&scoped=true"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"
import style0 from "./NewProfile.vue?vue&type=style&index=0&id=eba4628e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba4628e",
  null
  
)

export default component.exports